import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import type { LivenessErrorType } from '@/types/liveness'
import { livenessErrorCopy, selfieCopy } from '@/Pages/Selfie/copy'
import '@/Pages/Selfie/components/SelfieHelpScreen.sass'

type Props = {
  errorType: LivenessErrorType
  attempts: number
  maxAttempts: number
  onRetry: () => void
  onContactSupport: () => void
}

export const SelfieHelpScreen = ({
  errorType,
  attempts,
  maxAttempts,
  onRetry,
  onContactSupport,
}: Props) => {
  const { title, description } = livenessErrorCopy[errorType]
  const canRetry = attempts < maxAttempts

  return (
    <Box className="selfie-help-screen">
      <Box className="selfie-help-screen__content">
        <WarningAmberOutlinedIcon className="selfie-help-screen__icon" />
        <Typography component="h2" className="selfie-help-screen__title">
          {title}
        </Typography>
        <Typography className="selfie-help-screen__description">{description}</Typography>
      </Box>
      <Box className="selfie-help-screen__actions">
        {canRetry ? (
          <Button
            variant="contained"
            className="selfie-help-screen__button"
            onClick={onRetry}
          >
            {selfieCopy.retryButton}
          </Button>
        ) : (
          <Button
            variant="contained"
            className="selfie-help-screen__button"
            onClick={onContactSupport}
          >
            {selfieCopy.contactSupportButton}
          </Button>
        )}
      </Box>
    </Box>
  )
}
